import { useNavigate } from "react-router-dom";
import { logout } from "../../../../api/auth";
import { NavBarButtonDiv } from "./Buttons/NavBarButtonDiv";
import { FiLogOut } from "react-icons/fi";

/**
 * Component for the log out button in the Main Menu
 * 
 * Deletes the session token and logs the user out
 */
export function LogOut() {
    const navigate = useNavigate();

    const handleClick = async() => {
        try {
            const response = await logout();
            if (response[1] === "200") {
                // Only do this if the user logged in through Microsoft
                if (response[0] !== "") {
                    window.location.href = response[0];
                }
                // Otherwise, just navigate to the home page
                else {
                    navigate("/");
                }
            } else {
                console.error("Error logging out: ", response);
                navigate("/");
            }
        }
        catch (error) {
            console.error("Error logging out: ", error);
            navigate("/");
        }
    };
 
    return(
        <button className="flex flex-row justify-between w-full mx-auto transition hover:primary-color" onClick={handleClick}>
            <NavBarButtonDiv text="Logout" icon_name={<FiLogOut />} />
        </button>
    );
} 